module.exports = __webpack_public_path__ + "img/chat-left-fill.14bbf60f.svg";